import { render, staticRenderFns } from "./practiceResult.vue?vue&type=template&id=0e22d88e&scoped=true"
import script from "./practiceResult.vue?vue&type=script&lang=js"
export * from "./practiceResult.vue?vue&type=script&lang=js"
import style0 from "../css/practiceResult.scss?vue&type=style&index=0&id=0e22d88e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22d88e",
  null
  
)

export default component.exports